import React from 'react';
import NotificationContent from '../_partials/NotificationContent';
import { useCustomNotifications } from '../CustomNotificationContext';
export var CustomNotification = function (_a) {
    var notificationTypes = _a.notificationTypes, _b = _a.notificationFilter, notificationFilter = _b === void 0 ? function () { return true; } : _b, customNotificationRender = _a.customNotificationRender;
    var _c = useCustomNotifications(notificationTypes), notifications = _c.notifications, removeNotification = _c.removeNotification;
    var currentNotification = notifications[0];
    if (!currentNotification || !notificationFilter(currentNotification)) {
        return null;
    }
    return (React.createElement(NotificationContent, { notification: currentNotification, removeNotification: removeNotification }, customNotificationRender));
};
CustomNotification.displayName = 'CustomNotification';
export default CustomNotification;
//# sourceMappingURL=CustomNotification.js.map